import "@/App.css";
import { BrowserRouter, Navigate, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import FieldPage from "@/pages/FieldPage";
import LandingPage from "@/pages/LandingPage";
import { ContactPage, PrivacyPage, TermsPage } from "@/pages/InfoPages";
import GameDayPage from "@/pages/GameDayPage";
import LineupsPage from "@/pages/LineupsPage";
import StaffPage from "@/pages/StaffPage";
import TeamBoardPage from "@/pages/TeamBoardPage";
import AuthPage from "@/pages/AuthPage";
import AuthCallback from "@/pages/AuthCallback";
import CoachDashboard from "@/pages/CoachDashboard";
import TeamPlaybookPage from "@/pages/TeamPlaybookPage";
import JoinPage from "@/pages/JoinPage";
import PracticePage from "@/pages/PracticePage";
import PracticeStatsPage from "@/pages/PracticeStatsPage";
import PricingPage from "@/pages/PricingPage";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentPages";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center font-heading text-2xl">Checking login...</div>;
  return user ? children : <Navigate to="/login" replace />;
};

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/field" element={<FieldPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/login" element={<AuthPage />} />
      <Route path="/coach" element={<Protected><CoachDashboard /></Protected>} />
      <Route path="/coach/teams/:teamId" element={<Protected><TeamPlaybookPage /></Protected>} />
      <Route path="/join" element={<JoinPage />} />
      <Route path="/t/:code" element={<JoinPage />} />
      <Route path="/t/:code/practice" element={<PracticePage />} />
      <Route path="/coach/teams/:teamId/practice" element={<Protected><PracticeStatsPage /></Protected>} />
      <Route path="/coach/teams/:teamId/gameday" element={<Protected><GameDayPage /></Protected>} />
      <Route path="/coach/teams/:teamId/lineups" element={<Protected><LineupsPage /></Protected>} />
      <Route path="/coach/teams/:teamId/board" element={<Protected><TeamBoardPage /></Protected>} />
      <Route path="/c" element={<StaffPage />} />
      <Route path="/c/:code" element={<StaffPage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/payment/success" element={<Protected><PaymentSuccess /></Protected>} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
